import * as Yup from 'yup';

export const ServiceTicketValidationSchema = Yup.object({
  subject: Yup.string().required('Subject is required'),
  message: Yup.string().required('Message is required'),
  phoneNumber: Yup.number()
    .positive('Phone number must be positive')
    .integer('Phone number must be an integer')
    .required('Phone number is required'),
  priority: Yup.string().required('Priority is required'),
  status: Yup.string().required('Status is required'),
});
